<template>
  <main-menu v-if="apiToken && role"/>
  <v-layout row justify-center align-center wrap v-else>
    <v-flex xs10 sm8 md7 mt-4>
      <v-img
        src="/images/png/Logo.png"
      ></v-img>
    </v-flex>
    <v-flex xs10 sm8 md7 mt-5>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="email"
          :rules="emailRules"
          label="Usuario"
          placeholder="Usuario"
          required
          color="light-green darken-1"
        ></v-text-field>
        <v-text-field
          v-model="password"
          :append-icon="showPass ? 'fa-eye' : 'fa-eye-slash'"
          :rules="[passwordRules.required]"
          :type="showPass ? 'text' : 'password'"
          name="input-10-1"
          label="Contraseña"
          placeholder="Contraseña"
          counter
          @click:append="showPass = !showPass"
          color="light-green darken-1"
        ></v-text-field>
        <v-btn
          :disabled="!valid"
          @click="submit()"
          class="ma-0 mb-3"
          :class="formState"
          dark
        >
          <span v-if="loadingForm">Enviando, por favor espere <v-icon class="ml-2 spin">$vuetify.icons.circle-notch</v-icon></span>
          <span v-else>Enviar</span>
        </v-btn>
        <v-alert
          v-model="notification.value"
          dismissible
          :type="notification.type"
          transition="fade-transition"
        >
          {{notification.message}}
        </v-alert>
      </v-form>
    </v-flex>
  </v-layout>
</template>
<script>
import MainMenu from '@/views/MainMenu.vue';

export default {
  name: 'home',
  data() {
    return {
      showPass: false,
      valid: false,
      email: '',
      emailRules: [
        v => !!v || 'Este campo es requerido',
        // v => /.+@.+/.test(v) || 'Debe ser un email válido'
      ],
      password: '',
      passwordRules: {
        required: value => !!value || 'Este campo es requerido',
        // min: v => v.length >= 8 || 'Min 8 characters',
        // emailMatch: () => ('The email and password you entered don\'t match'),
      },
    };
  },
  // created() {
  //   window.setInterval(() => {
  //     this.apiToken ? '' : this.apiToken = window.localStorage.getItem('api_token');
  //     this.role ? '' : this.role = window.localStorage.getItem('role');
  //   }, 500) 
  // },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('logIn', {
          email: this.email,
          password: this.password,
        });
      } else {
        this.$store.commit('setFormNotification', {
          value: true,
          type: 'error',
          message: 'Revise los campos del formulario',
        });
      }
    },
    clear() {
      this.$refs.form.reset();
    },
  },
  computed: {
    notification() {
      return this.$store.state.form.notification;
    },
    loadingForm() {
      return this.$store.state.form.loading;
    },
    formState() {
      return this.$store.state.form.state;
    },
    apiToken() {
      return this.$store.state.sessionData.api_token;
    },
    role() {
      return this.$store.state.sessionData.role;
    }
  },
  components: {
    MainMenu,
  }
};
</script>
